// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"79":"d977b894","154":"fe07717b","187":"206821f4","410":"0b71384d","460":"3e0165dd","488":"80db2280","538":"0548c273","629":"f69bee85","677":"5d277258","791":"f492c27c","807":"fbf88189","813":"8f624ba7","888":"f3349814","990":"a44a0e18","995":"3babdb99"}[chunkId] + ".chunk.js";
};